import { PaymentCustomerSchema } from '../paymentCustomerSchema';

export const parsePaymentCustomer = (value: unknown) => {
    return PaymentCustomerSchema.parse(value);
};
